import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-6 flex justify-center">
          <Logo />
        </div>
        <div className="mb-8">
          <h1 className="text-7xl md:text-9xl font-mono font-bold text-[hsl(var(--flexaura-accent))] mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-primary mb-4">
            Page not found
          </h2>
          <p className="text-lg text-muted-foreground font-body mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="flex gap-3 justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/" aria-label="Return to Flexaura homepage">
              <Home className="w-4 h-4" aria-hidden="true" />
              Go home
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/faq">Contact support</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
